export default "__VITE_ASSET__5e970ae5__"